const steps = [
  {
    number: "01",
    title: "Discovery Call",
    description: "We discuss your goals, audience, and vision. No fluff—just the essentials to build exactly what you need.",
  },
  {
    number: "02",
    title: "Design & Development",
    description: "We get to work immediately. Custom design, clean code, optimized for speed from day one.",
  },
  {
    number: "03",
    title: "Review & Revisions",
    description: "You review the site, we refine it. Quick iterations until it's exactly right.",
  },
  {
    number: "04",
    title: "Launch & Handoff",
    description: "Your site goes live. We handle deployment, DNS, and provide full documentation.",
  },
];

const ProcessSection = () => {
  return (
    <section className="py-16 border-t border-border" aria-labelledby="process-title">
      <div className="container px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 animate-fade-in">
          <h2 id="process-title" className="text-3xl md:text-4xl font-bold mb-4">
            Our 3-7 Day Process
          </h2>
          <p className="text-muted-foreground text-lg">
            Simple, efficient, and focused on getting you live fast.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative animate-fade-in"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="bg-secondary/50 border border-border ring-1 ring-white/[0.08] dark:ring-white/[0.12] rounded-lg p-6 h-full">
                <span className="text-5xl font-bold text-primary/40" aria-hidden="true">{step.number}</span>
                <h3 className="text-xl font-semibold mt-2 mb-3">{step.title}</h3>
                <p className="text-muted-foreground">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 w-6 h-0.5 bg-border" />
              )}
            </div>
          ))}
        </div>

        <p className="text-center text-muted-foreground">
          <strong className="text-foreground">Average delivery:</strong> 3-7 business days
        </p>
      </div>
    </section>
  );
};

export default ProcessSection;
